<template>
  <div>
    <div class="no-print">
      <OappMenu v-if="roleid == '1' && !hideMenu" />
      <DppMenu v-if="(roleid == '2' || roleid == '3') && !hideMenu" />
      <AgentMenu v-if="roleid == '4' && !hideMenu" />
      <FarmerMenu v-if="roleid == '5' && !hideMenu" />
      <DasmMenu v-if="(roleid == '6' || roleid == '7') && !hideMenu" />
      <DasmMarketPurchaserMenu v-if="(roleid == '29') && !hideMenu" />
      <AccountMenu v-if="(roleid == '30' || roleid == '31') && !hideMenu" />
      <!-- <Issue v-if="(roleid == '32' || roleid == '33') && !hideMenu" /> -->
      <!-- // <MarketMenu v-if="roleid == '7' && !hideMenu" /> -->
      <ClinicMenu v-if="(roleid == '9' || roleid == '10') && !hideMenu" />
      <MarketChecker v-if="(roleid == '11' || roleid == '12') && !hideMenu" />
      <MarketManager v-if="(roleid == '23' || roleid == '24') && !hideMenu" />  
      <ICSCenterMenu
        v-if="
          (roleid == '25' ||
            roleid == '26' ||
            roleid == '27' ||
            roleid == '28') &&
            !ICSCenterMenu
        "
      />
      <AgrilaoMenu v-if="(roleid == '32') && !hideMenu" />
      <WaiterMenu v-if="(roleid == '77') && !hideMenu" />  
      <StockOutWaitMenu v-if="(roleid == '78') && !hideMenu" />  
    </div>
  </div>
</template>

<script>
import { get } from "vuex-pathify";
import OappMenu from "./OappMenu";
import DppMenu from "./DppMenu";
import DasmMenu from "./DasmMenu";
import DasmMarketPurchaserMenu from "./DasmMarketPurchaserMenu";
import AccountMenu from "./AccountMenu";
// import MarketMenu from "./MarketMenu";
import AgentMenu from "./AgentMenu";
import FarmerMenu from "./FarmerMenu";
import ClinicMenu from "./ClinicMenu";
import MarketChecker from "./MarketCheckerMenu";
import MarketManager from "./MarketManagerMenu";
import ICSCenterMenu from "./ICSCenterMenu";
// import Issue from "./IssueMenu";
import AgrilaoMenu from "./AgrilaoMenu";
import WaiterMenu from "./WaiterMenu";
import StockOutWaitMenu from "./StockOutWaitMenu";

export default {
  name: "Menu",
  components: {
    OappMenu,
    DppMenu,
    DasmMenu,
    AgentMenu,
    FarmerMenu,
    ClinicMenu,
    MarketChecker,
    MarketManager,
    ICSCenterMenu,
    DasmMarketPurchaserMenu,
    AccountMenu,
    // Issue,
    AgrilaoMenu,
    WaiterMenu,
    StockOutWaitMenu
  },
  computed: {
    roleid: get("loginData@ROLEID"),
    hideMenu() {
      let resolved = this.$router.resolve(this.$route.path);
      return resolved.route.name === "404";
    },
  },
};
</script>
